export default {
  'gift-cards': {
    'all-services-products': 'All services & products',
    'orders': {
      'search-placeholder': 'Search in orders...',
      'no-results': 'No Gift Cards Ordered Yet',
      'no-results-description': 'You will see orders for gift cards placed by your clients here. Make sure to set the giftcard as active, when you receive a payment from a client.',
      'delete-order': 'Remove this order?',
      'delete-order-description': 'If you remove this order it will be permanently deleted. You will no longer be able to confirm receipt of payment or send the Gift Card to the client.',
      'send': 'Gift Card sent to client',
    },
    'purchased': {
      'edit': 'Edit Gift Card',
      'search-placeholder': 'Search in purchased...',
      'no-results': 'No active gift cards',
      'no-results-description': 'Purchased gift cards will show up here. You must first confirm that you received payment (via whichever payment method you directed your clients to).',
    },
    'payment-details': {
      'description': 'Create a personalized message for clients to receive when they order your gift cards and let them know how they can complete payment.',
      'input-label': 'Add Payment Details',
    },
    'purchase-methods': {
      'online': {
        'title': 'Online',
        'description': 'Clients can purchase gift cards online at any time.',
        'description-not-activated': 'Allow clients to purchase Gift Cards instantly and at any time through Booksy by activating Mobile Payments.<br><br>Once activated, you\'ll be able to sell Gift Cards online from your Booksy Profile and in person through the Checkout tab.',
        'not-activated': 'Not activated',
        'activate': 'Activate Mobile Payments',
        'benefits-items': {
          'item-1-title': 'Convenience',
          'item-1-description': 'Clients can order Gift Cards from your Booksy Profile anytime.',
          'item-1-description-modal': 'Clients can order your Gift Cards anytime. So you can make sales even outside your regular working hours.',
          'item-2-title': 'Time-saving',
          'item-2-description': 'Can be purchased by clients in just a few clicks.',
          'item-3-title': 'Delivered immediately',
          'item-3-description': 'Once payment is authorized, the Gift Card is automatically sent to the client via email and available to them in app.',
        },
        'benefits-modal': {
          'title': 'Activate Mobile Payments',
          'text': 'Allow clients to purchase your Gift Cards online.',
          'description': 'Mobile Payments must be activated to allow clients to purchase Gift Cards online. Until you activate Mobile Payments you may sell Gift Cards in person for a limited time.',
        },
      },
      'in-person': {
        'title': 'In person',
        'description': 'Cards may be sold in person through the Checkout tab.',
        'available-until': 'Available until',
        'available-until-description': 'After this time Mobile Payments must be activated to sell Gift Cards online or in person.',
        'not-available': 'Not available',
        'available-until-date': 'Mobile Payments must be activated before <strong>{date}</strong> in order to continue selling Gift Cards.',
      },
      'external': {
        'title': 'Payment outside Booksy',
        'description': 'Create a personalized message for clients to receive when they order your gift cards and let them know how they can complete payment.',
        'input-label': 'Add Payment Details',
      },
      'pending-orders': 'You have {count} orders pending acceptance.',
      'pending-orders-go-to': 'Go to <strong>Pending Orders</strong> to resolve',
      'you-can-do-this-in': 'You can do this in',
      'purchase-methods': 'Purchase Method.',
      'cant-sell': 'Gift Cards cannot be sold until you activate Mobile Payments.',
      'enable-online-for-sale': 'Activate Mobile Payments to allow clients to purchase your Gift Cards.',
    },
    'modals-order': {
      'title': 'Order details',
      'payment-received': 'Confirm Payment',
      'gift-card-label': 'Gift card',
      'order-placed-label': 'Order Placed',
      'buyer': 'Purchaser',
      'cardholder': 'Card holder',
      'due-to': 'Amount Due',
      'badge-pending': 'Pending',
    },
    'modals-payment-received': {
      'title': 'Confirm payment of {itemPrice}?',
      'btn-confirm': 'Confirm',
    },
    'voucher-templates': {
      'general-description': 'Add details below to set up your Gift Card. When you\'re done, your clients will be able to access and purchase your Gift Card through the Booksy app.',
      'no-results': 'No Gift Cards Created Yet',
      'no-results-description': 'Create customized Gift Cards for your clients. You\'ll be able to add the Gift Card they select to their purchase at Checkout and redeem it for eligible services going forward. You can direct your clients to whichever payment method you\'d like, simply let them know in the "Payment Details" section.',
      'price-hint': 'Price is the amount the customer will pay for this Gift Card.',
      'value-hint': 'Value is amount this Gift Card can be redeemed for.',
      'add-service-title': 'Add Service to Gift Card',
      'template-created': 'Gift card created',
      'template-updated': 'Gift card updated',
      'template-deleted': 'Gift card deleted',
      'void': 'Void gift card',
    },
  },
  'membership': {
    'purchased': {
      'edit': 'Edit Membership',
      'search-placeholder': 'Search in purchased...',
      'no-results': 'No active memberships',
      'no-results-description': 'Set up Memberships to build customer loyalty. Done? Spread the word so your clients know they\'re available.',
    },
    'voucher-templates': {
      'general-description': 'Add details below to set up your Membership. When you\'re done, you\'ll be able to sell Memberships, encouraging clients to visit you more often.',
      'no-results': 'No Memberships Created Yet',
      'no-results-description': 'Create customized Memberships for your clients. You\'ll be able to add the Membership they select to their purchase at Checkout and redeem it for eligible services going forward.<br/>A membership card contains unlimited use of services or bookings within a specified time frame.',
      'price-hint': 'Price is the amount the customer will pay for this Membership.',
      'add-service-title': 'Add Service to Membership',
      'template-created': 'Membership created',
      'template-updated': 'Membership updated',
      'template-deleted': 'Membership deleted',
      'void': 'Void membership',
    },
  },
  'package': {
    'purchased': {
      'edit': 'Edit Package',
      'search-placeholder': 'Search in purchased...',
      'no-results': 'No packages available',
      'no-results-description': 'Set up Packages to streamline your checkout process. Done? Spread the word so your clients know they\'re available.',
    },
    'voucher-templates': {
      'general-description': 'Add details below to set up your Package. When you\'re done, you\'ll be able to sell Packages, encouraging clients to visit you more often.',
      'no-results': 'No Packages Created Yet',
      'no-results-description': 'Create customized Packages for your clients. You\'ll be able to add the Package they select to their purchase at Checkout and redeem it for eligible services going forward.<br/>and then redeem them later during a visit.',
      'price-hint': 'Price is the amount the customer will pay for this Package.',
      'add-service-title': 'Add Service to Package',
      'template-created': 'Package created',
      'template-updated': 'Package updated',
      'template-deleted': 'Package deleted',
      'void': 'Void package',
    },
  },
  'shared': {
    'overlays': {
      'voucher-template-form': {
        'add-gift-card': 'Add Gift Card',
        'general-info': 'General info',
        'gift-card-name': 'Gift card name',
        'description': 'Description',
        'price': 'Price',
        'value': 'Value',
        'current-balance': 'Current balance',
        'quantity': 'Quantity',
        'online-purchase': 'Available for online purchase',
        'rules': 'Rules',
        'valid-for': 'Valid for',
        'package-includes': 'Package includes',
        'expiration': 'Expires after',
        'membership-length': 'Length of Membership',
        'tax-rate': 'Tax Rate',
        'any-service': 'Any Service',
        'all-services': 'All Services',
        'edit-services': 'Edit Services',
        'selected': 'Selected',
        'template-created': 'Template created',
        'template-updated': 'Template updated',
        'template-deleted': 'Template deleted',
        'add-membership': 'Add Membership',
        'membership-name': 'Membership Name',
        'add-package': 'Add Package',
        'package-name': 'Package Name',
        'add-services': 'Add services',
        'add-service': 'Add service',
        'name-length-message': 'Name may not contain more than 50 characters.',
        'description-length-message': 'Description may not contain more than 128 characters.',
        'price-min-value-message': 'Price should be greater than 0',
        'value-min-value-message': 'Value should be greater than 0',
        'services-required-message': 'There should be at least one service',
        'price-min-value': 'Price should be greater than 0',
        'inactive-service': 'It doesn\'t look like you offer this service anymore. Your customer will see it in their package/membership but won\'t be able to redeem.',
        'preview-info': 'This card and a unique ID number will be sent to your client via e-mail once their Gift Card purchase is complete.',
        'edit-design': 'Edit Card Design',
        'usage-info': 'Gift Cards are not personalized and can be used by anyone with the card number<br/><br/>Gift Cards are not single use and can be used as many times as necessary until the balance is fully consumed',
        'services-description': 'Choose the services this Gift Card will be available for.<br /><br />You must select at least {count} services to create a Gift Card.',
        'giftcard-valid-till-hint': 'If you prefer to choose an option other than \'Never\', please ensure compliance with the gift card expiry date mandated by the state where your business operates. You may only switch to a different option if it aligns with legal requirements and permissions.',
      },
      'voucher-template-delete': {
        'confirm': 'Remove',
        'cancel': 'Go back',
        'gift-cards': {
          'title': 'Remove this Gift Card?',
          'description': 'Removing this Gift Card means clients will no longer be able to purchase it. This action cannot be undone.',
        },
        'memberships': {
          'title': 'Remove this Membership?',
          'description': 'Removing this Membership means clients will no longer be able to purchase it. This action cannot be undone.',
        },
        'packages': {
          'title': 'Remove this Package?',
          'description': 'Removing this Package means clients will no longer be able to purchase it. This action cannot be undone.',
        },
      },
      'voucher-template-preview': {
        'gift-card': 'Gift card',
        'placeholder-name': 'Gift card name',
        'price': 'Price',
        'value': 'Value',
        'all-services': 'All Services',
        'expires-after': 'Expires after',
        'modal': {
          'title': 'Gift Card Design',
          'confirm': 'Choose From Library',
          'error': 'Something went wrong.',
          'try-again': 'Please try again.',
          'retry': 'Retry',
        },
      },
      'voucher-details': {
        'confirm-redeem': 'Redeem',
        'redeem-history': 'Redeem History',
        'redeem-btn': 'Redeem',
        'package-redeem': 'Redeem',
        'membership-redeem': 'Redeem',
        'giftcard-redeem': 'Redeem',
        'redeemed': 'Redeemed',
        'sell-again-btn': 'Sell again',
        'no-redeem-history': 'No services have been redeemed yet',
        'giftcard-no-redeem-history': 'This Gift Card hasn\'t been redeemed yet',
        'regular-price': 'Regular price',
        'package-history': 'Package History',
        'membership-history': 'Membership History',
        'giftcard-history': 'Gift Card History',
      },
      'redeem': {
        'title': 'Redeem',
        'balance-left': 'Balance left',
        'amount': 'Amount',
        'amount-min-value-message': 'Amount should be greater than 0',
        'package-min-value-message': 'At least one value should be greater than 0',
        'success': 'Redeemed',
        'membership-title': 'Redeem membership',
        'membership-redeem': 'Redeem one appointment with a membership?',
      },
    },
    'voucher-templates': {
      'no-payment-details-title': 'Let clients know how to pay.',
      'no-payment-details-btn': 'Add payment details',
      'no-payment-details': 'Create a personalized message for clients to receive when they order your gift cards and let them know how they can complete payment.',
    },
    'voucher-card': {
      'balance': 'Balance',
      'valid-till': 'Expires',
      'valid-from': 'Valid from',
      'redeemed': 'Redeemed',
      'validity': 'Expires',
      'owner': 'Owner',
      'issued': 'Issued',
      'card-holder': 'Card holder',
    },
    'ux': {
      'see-barcode': 'Tap on card to see barcode.',
      'copy-barcode': 'Tap to copy barcode',
    },
    'invalidate-modal': {
      'title': 'Are u sure?',
      'description-gift-card': 'You are about to void gift card.',
      'description-membership': 'You are about to void membership.',
      'description-package': 'You are about to void package.',
      'confirm': 'Yes, void',
    },
  },
  'consts': {
    'expiration-options': {
      'never': 'Never',
      '30-days': '30 days',
      '90-days': '90 days',
      '6-months': '6 months',
      '1-year': '1 year',
      'till-end-of-month': 'Till end of month',
      'till-end-of-year': 'Till end of year',
    },
  },
  'how-it-works': {
    'gift-cards': {
      'title': 'How it works?',
      'content': {
        'main': 'Create your own Gift Cards to allow your clients to purchase your services as a thoughtful present for friends, family, colleagues or even themselves!<br><br>Design the card the way you want, set the price, period of validity and services that the card may be used for.<br><br>You may also enable or disable the option to have this card available for online purchase. ',
        'manage-gift-cards-heading': 'Manage Gift Cards',
        'manage-gift-cards-text': 'Here you can manage and make changes to Gift Cards you have already created and create new ones. (Please note that any changes made to existing Gift Cards will only apply to cards purchased after the changes are saved and will not modify cards that have already been sold).',
        'pending-orders-heading': 'Pending Orders',
        'pending-orders-text': 'Any orders made prior to activation of mobile payments that are pending approval will show here.',
        'pending-orders-text-legacy': 'Here you can manage orders that are not yet completed and follow up with any clients who may need help completing their purchase.',
        'purchased-heading': 'Purchased',
        'purchased-text': 'Here you will find a list of completed orders so you can keep track of and manage sold Gift Cards.',
        'completed-orders-heading': 'Completed Orders',
        'purchase-methods-heading': 'Purchase methods',
        'purchase-methods-text': 'Here you can view and manage how clients are able purchase your Gift Cards and check the status of your account to see how you are eligible to sell.',
        'purchase-methods-text-legacy': 'Here you can view and manage how clients are able to purchase your Gift Cards and provide important information for clients to complete payments.',
      },
    },
  },
}
